<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'ServicesReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/services'
    }
  }
}
</script>
